import {
  cn
} from "./chunk-SBEJSA5Q.js";

// src/components/ui/tooltip.tsx
import * as React from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { cva } from "class-variance-authority";
import { jsx, jsxs } from "react/jsx-runtime";
var tooltipContentVariants = cva(
  "z-50 overflow-hidden rounded-md border border-border bg-popover text-popover-foreground shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
  {
    variants: {
      size: {
        sm: "px-2 py-1 text-xs",
        md: "px-3 py-1.5 text-xs",
        lg: "px-4 py-2 text-sm",
        xl: "px-5 py-2.5 text-sm"
      }
    },
    defaultVariants: {
      size: "md"
    }
  }
);
var TooltipProvider = ({ delayDuration = 200, ...props }) => /* @__PURE__ */ jsx(
  TooltipPrimitive.Provider,
  {
    "data-slot": "tooltip-provider",
    delayDuration,
    ...props
  }
);
TooltipProvider.displayName = "TooltipProvider";
var Tooltip = ({
  ...props
}) => /* @__PURE__ */ jsx(TooltipPrimitive.Root, { "data-slot": "tooltip", ...props });
Tooltip.displayName = "Tooltip";
var TooltipTrigger = React.forwardRef(({ ...props }, ref) => /* @__PURE__ */ jsx(TooltipPrimitive.Trigger, { "data-slot": "tooltip-trigger", ref, ...props }));
TooltipTrigger.displayName = "TooltipTrigger";
var TooltipContent = React.forwardRef(({ className, sideOffset = 4, size, children, ...props }, ref) => {
  const contentSize = size || "md";
  return /* @__PURE__ */ jsx(TooltipPrimitive.Portal, { children: /* @__PURE__ */ jsxs(
    TooltipPrimitive.Content,
    {
      "data-slot": "tooltip-content",
      sideOffset,
      className: cn(tooltipContentVariants({ size: contentSize }), className),
      ref,
      ...props,
      children: [
        children,
        /* @__PURE__ */ jsx(TooltipPrimitive.Arrow, { className: "fill-border animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95" })
      ]
    }
  ) });
});
TooltipContent.displayName = "TooltipContent";

export {
  tooltipContentVariants,
  TooltipProvider,
  Tooltip,
  TooltipTrigger,
  TooltipContent
};
//# sourceMappingURL=chunk-OERUTHPZ.js.map